import React, { Component } from "react";
import Layout from "./../layouts/Index";
import { withRouter } from "react-router-dom";
import { Formik } from "formik";
import { toast } from "react-toastify";
// import axios from 'axios';
import { instance, setAuthToken } from "../../helpers/instance";
import { Row, Col, Button, Form, Card, Modal } from "react-bootstrap";
import { sendMessageSchema } from "./../../helpers/validation/sms";

class SendSMS extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
    };
  }

  render() {
    const { loading } = this.state;

    return (
      <Layout>
        <Row style={{ minHeight: "100vh", padding: "3em 0" }}>
          <Col md={{ span: 6, offset: 3 }}>
            <Card style={{ padding: "20px" }}>
              <Formik
                initialValues={{ msisdn: "", message: "" }}
                validationSchema={sendMessageSchema}
                onSubmit={async (values, { setSubmitting, resetForm }) => {

                  let data = values.msisdn.split("\n");

                  values.msisdn = data;

                  this.setState({ loading: true });

                  setAuthToken(instance);

                  const response = await instance.post("sms", values);

                  if (response.data !== "") {
                    this.setState({ loading: false });

                    toast.success("Message Sent To " + values.msisdn.length + " Recipients!", {
                      position: "bottom-center",
                    });

                    resetForm();
                  } else {
                    this.setState({ loading: false });
                  }
                }}
              >
                {({
                  values,
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                  isSubmitting,
                  setFieldValue
                }) => (
                  <div>
                    <Modal.Header style={{ marginBottom: "2em" }}>
                      <Modal.Title>Send Message</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                      <Form.Group
                        as={Row}
                        controlId="phone_number"
                        style={{ marginBottom: "1em" }}
                      >
                        <Form.Label column sm="3">
                          Phone Numbers
                        </Form.Label>

                        <Col sm="9">
                          {/* <Form.Control type="text" placeholder="Phone Number" name="msisdn" isValid={touched.msisdn && !errors.msisdn} isInvalid={errors.msisdn && touched.msisdn} value={values.msisdn} onChange={handleChange} /> */}

                          <Form.Control
                            as="textarea"
                            rows={3}
                            placeholder="Phone Numbers (one per line)"
                            name="msisdn"
                            isValid={touched.msisdn && !errors.msisdn}
                            isInvalid={errors.msisdn && touched.msisdn}
                            value={values.msisdn}
                            onChange={handleChange}
                          />

                          {errors.msisdn && touched.msisdn && (
                            <Form.Control.Feedback type="invalid">
                              {errors.msisdn}
                            </Form.Control.Feedback>
                          )}
                        </Col>
                      </Form.Group>

                      <Form.Group
                        as={Row}
                        controlId="message"
                        style={{ marginBottom: "1em" }}
                      >
                        <Form.Label column sm="3">
                          Message
                        </Form.Label>

                        <Col sm="9">
                          <Form.Control
                            as="textarea"
                            rows={3}
                            placeholder="Write..."
                            name="message"
                            isValid={touched.message && !errors.message}
                            isInvalid={errors.message && touched.message}
                            value={values.message}
                            onChange={handleChange}
                          />

                          {errors.message && touched.message && (
                            <Form.Control.Feedback type="invalid">
                              {errors.message}
                            </Form.Control.Feedback>
                          )}
                        </Col>
                      </Form.Group>
                      <Form.Group
                        as={Row}
                        controlId="message"
                        style={{ marginBottom: "1em" }}
                      >
                        <Form.Label column sm="3">
                          &nbsp;
                        </Form.Label>
                        <Col sm="9">
                          {/** add whatsapp_only: true if checkbox is checked, if not whatsapp_only: false */}
                          <Form.Check
                            type="checkbox"
                            name="whatsapp_only"
                            label="Send via WhatsApp only(Strictly Marketing Messages)"
                            checked={values.whatsapp_only === true}
                            onChange={(e) =>
                              setFieldValue("whatsapp_only", e.target.checked)
                            }
                            isInvalid={errors.whatsapp_only && touched.whatsapp_only}
                          />

                        </Col>
                      </Form.Group>
                    </Modal.Body>

                    <Modal.Footer>
                      <Button
                        variant="primary"
                        onClick={handleSubmit}
                        disabled={loading}
                      >
                        {loading ? "Sending..." : "Send SMS"}
                      </Button>
                    </Modal.Footer>
                  </div>
                )}
              </Formik>
            </Card>
          </Col>
        </Row>
      </Layout>
    );
  }
}

export default withRouter(SendSMS);
